<template>
  <span :class="linkClasses">
    <template v-if="btnColor === 'white'">
      <router-link :to="link" v-ripple.mouseover="'rgba(83, 115, 255, 0.1)'">{{btnText}}</router-link>
    </template>
    <template v-else>
      <router-link :to="link" v-ripple.mouseover="'rgba(255, 255, 255, 0.1)'">{{btnText}}</router-link>
    </template>
  </span>
</template>

<script>
export default {
  name: 'RoundedButton',
  props: {
    btnColor: {
      type: String,
      required: false,
      default: 'white'
    },
    btnIcon: {
      type: String,
      required: false,
      default: 'plus'
    },
    btnText: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: false,
      default: '/'
    }
  },
  computed: {
    linkClasses: function () {
      return 'page-controller btn ' + this.btnColor + ' ' + this.btnIcon
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";

span {
  text-align: center;
  display: block;
  line-height: 1;
}
span a {
  white-space: nowrap;
  font-family: $secondaryFont;
  font-weight: $secondaryFontBold;
  padding:10px 30px 10px 30px;
  margin: 12px 0 8px 0;
  border: none;
  background: transparent;
  background: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  display:inline-block;
  overflow:hidden;
  font-size:16px;
  line-height:1;
  border-radius:25px;
  position:relative;
  transform: translate3d(0,0,0); // ripple bug
}
span a::-moz-focus-inner {
  border: 0;
  padding: 0;
}
span a:before {
  content:'';
  display:inline-block;
  background-position:center center;
  background-repeat:no-repeat;
  margin-right:6px;
  position: relative;
  top: 2px;
}
.blue a,
.blue a:hover,
.blue a:focus,
.blue a:active,
.blue a:visited {
  background:#5373FF;
  color:#fff;
  text-decoration:none;
}
.white a,
.white a:hover,
.white a:focus,
.white a:active,
.white a:visited  {
  background:#fff;
  color:#5373FF;
  text-decoration:none;
}
.check a:before {
  width:15px;
  height:13px;
}
.blue.check a:before {
  background-image:url('../assets/img/icons/buttons/checkwhite.svg');
}
.white.check a:before {
  background-image:url('../assets/img/icons/buttons/checkblue.svg');
}
.plus a:before {
  width: 15px;
  height: 15px;
}
.blue.plus a:before {
  background-image:url('../assets/img/icons/buttons/pluswhite.svg');
}
.white.plus a:before {
  background-image:url('../assets/img/icons/buttons/plusblue.svg');
}
@media (min-width:767px) {
  span a {
    font-size:18px;
  }
  span a:before {
    margin-right:8px;
  }
  .check a:before {
    width:17px;
    height:15px;
  }
  .plus a:before {
    width: 17px;
    height: 17px;
  }
}
</style>
